const APP_LABELS: Record<string, string> = {
    'code.exe': 'Visual Studio Code',
    'idea64.exe': 'IntelliJ IDEA',
    'devenv.exe': 'Visual Studio',
    'notion.exe': 'Notion',
    'obsidian.exe': 'Obsidian',
    'pycharm64.exe': 'PyCharm',
    'webstorm64.exe': 'WebStorm',
    'datagrip64.exe': 'DataGrip',
    'kakaotalk.exe': '카카오톡',
    'discord.exe': 'Discord',
    'steam.exe': 'Steam',
    'spotify.exe': 'Spotify',
    'youtubemusic.exe': 'YouTube Music',
    'clock.exe': '시계',
    'calculator.exe': '계산기',
    'windowsterminal.exe': 'Windows Terminal',
    'explorer.exe': '파일 탐색기',
    'chrome.exe': 'Chrome',
    'msedge.exe': 'Microsoft Edge',
    'firefox.exe': 'Firefox',
    'notepad.exe': '메모장',
    'notepad++.exe': 'Notepad++',
    'powerpnt.exe': 'PowerPoint',
    'winword.exe': 'Word',
    'excel.exe': 'Excel',
    'onenote.exe': 'OneNote',
    'slack.exe': 'Slack',
    'teams.exe': 'Teams',
    'zoom.exe': 'Zoom',
};

// 실행 파일명(예: WindowsTerminal.exe) 대신 사람이 알아볼 수 있는 이름으로.
// 서버가 내려준 이름(serverName)이 있으면 그걸 우선, 없으면 로컬 목록, 그것도 없으면 원본.
export const displayLabel = (value: string, serverName?: string): string =>
    serverName || APP_LABELS[value.toLowerCase()] || value;
